import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import type {
  ZitadelServiceUser,
  ZitadelServiceUserWithCredentials,
} from "@src/types/user-management";

export interface PostCreateUserResult {
  success: boolean;
  data?: ZitadelServiceUserWithCredentials;
  error?: string;
}

export const postCreateServiceUserUseCase = async (
  user: Partial<ZitadelServiceUser>,
): Promise<PostCreateUserResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.postCreateServiceUser(namespace, user);

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to create service user. Please try again later.",
      ).message,
    };
  }
};
